
import { defineComponent, ref, onMounted } from "vue";
import {
  Course,
  CourseType,
  GetCourseTypeResponse,
  TrainingTypeEnum,
  UpsertCourseRequest,
  CourseDetailDto,
  TrainingDocumentDetailDto,
} from "@/types";
import { usePlugin } from "@/plugins";
import TrainingDocumentList from "../../components/TrainingDocumentList.vue";
import { useQRCode } from "@vueuse/integrations";
import BackButton from "@/components/BackButton.vue";
export default defineComponent({
  components: { TrainingDocumentList, BackButton },
  name: "CourseMaintain",
  setup() {
    const { success, error, axios, setLoading, padZero, route } = usePlugin();
    let courseTypes = ref<CourseType[]>([]);
    const course = ref<Course>({} as Course);
    const trainingDocumentDetailDto = ref<TrainingDocumentDetailDto[]>([]);

    const loadCourseTypes = async () => {
      setLoading(true);
      try {
        const result = await axios.get<GetCourseTypeResponse>(
          "api/v1/services/courseType/get"
        );
        courseTypes.value = result.data.courseTypes ?? [];
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };
    const loadCourse = async () => {
      if (route.params.id) {
        setLoading(true);
        try {
          const result = await axios.get<CourseDetailDto>(
            `api/v1/services/course/${route.params.id}`
          );
          course.value = result.data.course ?? ({} as Course);
          trainingDocumentDetailDto.value =
            result.data.trainingDocumentDtos ?? [];
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    const onSaveCourse = async () => {
      if (course.value.id && course.value.id.length > 0) {
        setLoading(true);
        try {
          const result = await axios.post("api/v1/services/course/upsert", {
            courses: [
              {
                id: padZero(course.value.id, 7),
                description: course.value.description,
                courseTypeId: course.value.courseTypeId,
              },
            ],
          } as UpsertCourseRequest);
          await loadCourse();
          success("บันทึกข้อมูลสำเร็จแล้ว");
          // showDialog.value = false;
        } catch (e) {
          error(e);
        } finally {
          setLoading(false);
        }
      }
    };

    onMounted(async () => {
      await loadCourseTypes();
      await loadCourse();
    });

    return {
      courseTypes,
      course,
      onSaveCourse,
      TrainingTypeEnum,
      trainingDocumentDetailDto,
      loadCourse,
    };
  },
});
